
import { CompoundProductionStepDto, CreateCompoundProductionStepDto, UpdateCompoundProductionStepDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { compoundProductionStepService, CompoundProductionStepsFilters } from '@services/CompoundProductionStepService'

const { reducer, actions, thunks } = baseCrudReducer<
  CompoundProductionStepDto,
  CreateCompoundProductionStepDto,
  UpdateCompoundProductionStepDto,
  CompoundProductionStepsFilters
>('compoundProductionStep', compoundProductionStepService)

export default reducer

export const { setFilters: setCompoundProductionStepFilters } = actions

export const {
  getAll: getCompoundProductionSteps,
  create: createCompoundProductionStep,
  update: updateCompoundProductionStep,
  remove: removeCompoundProductionStep,
} = thunks
